<template>
  <div class="headercomponent">
    <component :is="headingTag" :class="headingClass" v-bind="$attrs" v-html="title" />
    <p v-if="text" :class="['mt-2 text-sm text-gray-500', textClass]" v-html="text"></p>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  title?: string
  text?: string
  heading?: number
  textClass?: string
}>()

const headingTag = computed(() => `h${props.heading ?? 1}`)

const headingClass = computed(() => {
  const base = 'tracking-tight text-gray-900'
  const bold = `font-bold + ${base}`
  const medium = `font-medium + ${base}`
  const normal = `font-normal + ${base}`

  const headingClasses: Record<number, string> = {
    1: `text-2xl ${bold}`,
    2: `text-xl ${bold}`,
    3: `text-base ${bold}`,
    4: `text-base ${medium}`,
    5: `text-base ${normal}`
  }

  return headingClasses[props.heading ?? 1]
})
</script>
